import React, { useRef } from "react";
import { Eye } from "lucide-react";
import { ProfileData } from "@/hooks/useProfiles";
import { trackProfileAction } from "@/utils/analytics";
import { LikeButton } from "./LikeButton";

interface ProfileStatsSectionProps {
  viewCount?: number;
  likeCount?: number;
  isLiked?: boolean;
  onViewClick?: (e: React.MouseEvent) => void;
  onLikeClick?: (e: React.MouseEvent) => void;
  profile?: ProfileData;
}

const ProfileStatsSection: React.FC<ProfileStatsSectionProps> = ({
  viewCount: propViewCount,
  likeCount: propLikeCount,
  isLiked: propIsLiked,
  onViewClick,
  onLikeClick,
  profile,
}) => {
  // Use provided props or derive from profile
  const viewCount = propViewCount ?? profile?.view_count ?? 0;

  const handleViewClick = (e: React.MouseEvent) => {
    if (profile?.id) {
      trackProfileAction("view_stats", profile.id);
    }

    if (onViewClick) {
      onViewClick(e);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <button
        onClick={handleViewClick}
        className="flex items-center gap-1 hover:text-primary transition-colors cursor-pointer group"
      >
        <Eye className="h-4 w-4 text-gray-500 group-hover:text-primary" />
        <span className="text-sm font-medium">{viewCount}</span>
        <span className="text-sm text-muted-foreground">views</span>
      </button>

      {profile && profile.id ? (
        <LikeButton
          profileId={profile.id}
          showCount
          variant="ghost"
          size="sm"
          className="hover:bg-transparent p-0 h-auto"
        />
      ) : (
        <div className="flex items-center gap-1">
          <span className="text-sm font-medium">{propLikeCount || 0}</span>
          <span className="text-sm text-muted-foreground">likes</span>
        </div>
      )}
    </div>
  );
};

export default ProfileStatsSection;
